import { Component, forwardRef, ViewChild, Input, Inject } from '@angular/core';
import { PlatformApiService, ResultFilter, Results } from '../../services/platform-api.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { Account, RoleType } from 'src/app/models/AccountModel';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'cw-ci-new-key-display',
  template: `
  <div class="dashboard-tile" id="show-new-key" style="max-width:400px;">
    <div class="tile-header">
      <div class="tile-header-title">Api Key</div>
    </div>
    <div class="tile-content">
      <div class="text-warn" style="padding-top: 20px;margin-bottom: 9px;box-sizing: border-box;">Please keep a secure copy of the private key. After closing this window, it will not be accessible again.</div>
      <div style="padding:20px 10px;">
        <div>Public Key: <span class="text-primary">{{data.publicKey}}</span></div>
        <div>Private Key: <span class="text-primary">{{data.privateKey}}</span></div>
      </div>
      <div class="tile-footer centered">
        <button mat-raised-button color="primary" mat-dialog-close>Ok</button>
      </div>
  </div>
  `
})
export class ShowNewApiKeyComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }
}

@Component({
  selector: 'cw-ci-account-api-keys',
  templateUrl: './account-api-keys.component.html',
  styleUrls: ['./account-api-keys.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => AccountApiKeysComponent)}]
})

export class AccountApiKeysComponent extends WizardScreenComponent {
  @ViewChild(DataTableComponent, { static: true }) keyDataTable: DataTableComponent;
  apiKeyList: Results;

  @Input()
  account: Account;
  RoleType = RoleType;

  constructor(private _platformApi: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) {
    super();
  }

  onLoad() {
    if(!this.sessionService.hasRole(RoleType.ADMIN) && this.sessionService.isAccountType('SYSTEM')) {
      this.keyDataTable.disableAdd = true;
    }
    this.keyDataTable.executeLoadItems();
    super.onLoad();
  }

  loadApiKeys(filter = new ResultFilter()) {
    this.keyDataTable.showProcessing();

    this._platformApi.getApiKeys(this.account.id).subscribe(keys => {
      this.apiKeyList = new Results(keys, keys.length);
    });
  }

  addKey(event?) {
    this._platformApi.createApiKey(this.account.id).subscribe(newKey => {
      console.log(newKey);
      this.dialog.open(ShowNewApiKeyComponent, {
        // width: '400px',
        // height: '250px',
        panelClass: 'flush-dialog',
        data: { publicKey: newKey.publicKey, privateKey: newKey.privateKeyHash },
      });

      this.loadApiKeys();
    })
  }

  isDirty() {
    return false;
  }

  isValid() {
    return true;
  }
}